import type { TFunction } from 'i18next';
import type { AnySchema } from 'yup';
import { object, string } from 'yup';
import type { TSetPermanentPasswordFormFields } from '@features/auth/lib/types';
export const getTranslatedScheme = (t: TFunction) => object<Record<keyof TSetPermanentPasswordFormFields, AnySchema>>({
  password: string().required(t('passwordRequired')).min(8, t('passwordMin', {
    num: 8
  })).matches(/^(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).*$/, t('passwordCharacters')).matches(/^(?=.*[A-Z]).*$/, t('passwordCapital'))
});